// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"308":"db726498","492":"5f86dc96"}[chunkId] + ".chunk.css";
};